import React from 'react'
import { Link } from 'react-router-dom'
import JobStatusChanger from './Components/JobStatusChanger'
import { KTSVG } from '_metronic/helpers'
import DocumentStatus from './Components/DocumentStatus'
import SurveyFormHeader from './Components/Header'
import Pile from './Components/Pile'
import Installation from './Components/Installation'
import Obstacle from './Components/Obstacle'
import FinancialRisk from './Components/FinancialRisk'
import useViewModel from './ViewModel'
import moment from 'moment'
import clsx from 'clsx'

const SurveyFormContent: React.FC = () => {
  const {
    saleUserOptions,
    isCreate,
    isView,
    currentStep,
    disabledSubmitButton,
    survey,
    formik,
    saleOrder,
    saleOrderItems,
    surveyLoading,
    onDownloadPdf,
    onChangeSaleOrderItem,
    saleOrderOptions,
    prevStep,
    openStatusModal,
    handleOpenStatusModal,
    handleCloseStatusModal,
    onChangeStatus,
    onSubmitStatus,
    handleOpenSelectLocation,
    onChangeSaleOrderHeader,
    onChangeSaleUserHeader,
    onChangeInstallationCategory,
    onCheckInstallationCategory,
    onChangeFactoryDistance,
    setHasPressedSubmit,
    latestVersion,
    versions,
    onSaveHistory,
  } = useViewModel()

  return (
    <>
      <JobStatusChanger
        open={openStatusModal}
        handleClose={handleCloseStatusModal}
        handleSubmit={onSubmitStatus}
        value={formik.values.jobStatus}
        onChange={onChangeStatus}
      />

      <div id='survey-form-main-pointer' />
      <form
        onSubmit={(e: any) => {
          e.preventDefault()
          setHasPressedSubmit(true)
          formik.handleSubmit(e)
        }}>
        <div className='row gy-5'>
          <div className='col-12'>
            <div className='card'>
              <div className='card-footer'>
                <div
                  className='d-flex flex-column flex-xl-row justify-content-xl-between align-items-xl-center'
                  style={{ rowGap: '30px' }}>
                  <div>
                    <DocumentStatus
                      isView={isView}
                      updatedAt={formik.values.updatedAt}
                      documentStatus={formik.values.documentStatus}
                      jobStatus={survey.jobStatus}
                    />

                    {versions && versions.length > 0 && (
                      <div className='mt-3'>
                        <div>
                          <span className='fw-bold'>คุณกำลังดู Version ที่: </span>
                          <span>
                            {survey.revision} {survey.revision === latestVersion && '(ล่าสุด)'}
                          </span>
                        </div>

                        <div className='fw-bold mt-3'>ประวัติการแก้ไข</div>
                        {versions.map((version: any, idx: number) => (
                          <div key={idx} className='mt-2'>
                            <Link
                              to={`/survey/${version.id}/form${
                                version.revision === latestVersion ? '' : '?view=1'
                              }`}
                              style={{ fontSize: '14px' }}>
                              Version {version.revision} : สร้างขึ้นเมื่อวันที่{' '}
                              {moment(version.createdAt).format('DD/MM/YYYY')}
                            </Link>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className='text-center text-xl-end'>
                    {!isCreate && !isView && (
                      <button
                        type='button'
                        className='btn btn-sm btn-primary fw-bold me-4'
                        onClick={handleOpenStatusModal}>
                        แก้ไขสถานะงาน
                      </button>
                    )}

                    {!isCreate && !isView && survey?.revision === latestVersion && (
                      <button
                        type='button'
                        className='btn btn-sm btn-primary fw-bold me-4'
                        onClick={onSaveHistory}>
                        บันทึกประวัติข้อมูล
                      </button>
                    )}

                    {!isCreate && (
                      <button
                        type='button'
                        disabled={surveyLoading === true}
                        onClick={onDownloadPdf}
                        className='btn btn-sm btn-secondary fw-bold'>
                        <KTSVG
                          path='/media/icons/duotune/files/fil017.svg'
                          className='svg-icon svg-icon-1x svg-icon-primary'
                        />
                        พิมพ์เอกสาร
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12' id='survey-form-header-pointer'>
            <SurveyFormHeader
              isView={isView}
              formik={formik}
              saleOrder={saleOrder}
              saleOrders={saleOrderOptions}
              saleUserOptions={saleUserOptions}
              handleOpenSelectLocation={handleOpenSelectLocation}
              onChangeSaleOrderHeader={onChangeSaleOrderHeader}
              onChangeSaleUserHeader={onChangeSaleUserHeader}
            />
          </div>

          <div className='col-12'>
            <Pile isView={isView} data={saleOrderItems} onChange={onChangeSaleOrderItem} />
          </div>

          {currentStep === 1 && (
            <div className='col-12'>
              <Installation
                isView={isView}
                formik={formik}
                onCheckInstallationCategory={onCheckInstallationCategory}
                onChangeInstallationCategory={onChangeInstallationCategory}
                onChangeFactoryDistance={onChangeFactoryDistance}
              />
            </div>
          )}

          {currentStep === 2 && (
            <div className='col-12'>
              <Obstacle isView={isView} formik={formik} />
            </div>
          )}

          {currentStep === 3 && (
            <div className='col-12'>
              <FinancialRisk isView={isView} formik={formik} />
            </div>
          )}

          <div className='col-12'>
            <div className='card'>
              <div className='card-footer text-end'>
                {currentStep !== 1 && (
                  <button
                    type='button'
                    className='btn btn-sm btn-light me-5'
                    onClick={() => {
                      prevStep()
                      document.getElementById('survey-form-main-pointer')?.scrollIntoView({
                        behavior: 'smooth',
                      })
                    }}>
                    ย้อนกลับ
                  </button>
                )}

                <button
                  className={clsx('btn btn-sm', {
                    'btn-primary': currentStep !== 3,
                    'btn-success': currentStep === 3,
                    'd-none': isView && currentStep === 3,
                  })}
                  type='submit'
                  disabled={disabledSubmitButton}>
                  {currentStep !== 3 ? 'ถัดไป' : 'บันทึก'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default SurveyFormContent
